export default __webpack_public_path__ + "static/media/light-word.5792018b.png";